





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  between,
  minValue,
  maxValue,
  minValueRef,
} from 'vuelidate/lib/validators';
import MaskedInput from 'vue-masked-input';
import Navigator from '../Study/Navigator.vue';
import { bus, store, client } from '../../shared';
import { UserInfo } from '../../shared/user';
import moment from 'moment';
import {
  iacucStatus,
  IdealMinOptions,
  meetingOptions,
  shippingSerumOptions,
  referrals,
} from '../../shared/constants';
import { ToggleButton } from 'vue-js-toggle-button';
import _ from 'lodash';
import { deepClone } from '@/shared/utils';
@Component({
  components: {
    MaskedInput,
    ToggleButton,
  },
})
export default class ProtocolInfo extends Vue {
  /* ------------- Data -------------------- */
  $v: any;
  isHydrated: boolean = false;
  userInteracted = false;
  ctx: any;
  formatted: any;
  selected: any;
  iacucStatus: any = iacucStatus;
  remaincharactersText = '';
  remainAbstractCharactersText = '';
  exceedingAbstractText = '';
  remainSpecificAimscharactersText = '';
  remainmethodcharactersText = '';
  remainingResearchMethodsCharactersText = '';
  exceedingResearchMethodsText = '';
  remainisletcharactersText = '';
  exceedingIsletsText = '';
  remainingIsletsCharactersText = '';
  reqIsletText =
    'Rationale for Freshly-Cultured Isolated Islets is required and must be at least 2 characters long..';
  remainhistocharactersText = '';
  exceedingHistoSlidesText = '';
  remainingHistoSlidesCharactersText = '';
  reqHistoText =
    'Rationale: Formalin-Fixed Pancreas Tissue Sections (Histology Slides) is required and must be at least 2 characters long..';
  remainacinarcharactersText = '';
  exceedingAcinarText = '';
  remainingAcinarCharactersText = '';
  reqAcinarText =
    'Rationale: Non-Islet Pancreatic Tissue (Acinar) is required.';
  remainfrozencharactersText = '';
  exceedingFrozenIsletsText = '';
  remainingFrozenIsletsCharactersText = '';
  reqFrozenText =
    'Rationale: Flash Frozen Isolated Islets is required and must be at least 2 characters long..';

  remainBloodcharactersText = '';
  exceedingBloodText = '';
  remainingBloodCharactersText = '';
  reqBloodText =
    'Rationale: Blood Products is required and must be at least 2 characters long.';
  remainAncillarycharactersText = '';
  exceedingAncillaryText = '';
  remainingAncillaryCharactersText = '';
  reqAncillaryText =
    'Rationale: Ancillary Tissue is required and must be at least 2 characters long..';
  hasResearchArea: boolean = false;
  /*study requirements*/
  IdealMinOptions: any = IdealMinOptions;
  meetingOptions: any = meetingOptions;
  shippingSerumOptions: any = shippingSerumOptions;
  now: any = new Date();
  today: any = new Date(
    this.now.getFullYear(),
    this.now.getMonth(),
    this.now.getDate(),
  );
  min: any = this.now;
  minPurity: any;
  maxPurity: any;
  greaterThanZero: any;
  hasIsletInterest: boolean = false;
  hasAcinarInterest: boolean = false;
  hasFrozenInterest: boolean = false;
  hasHistoInterest: boolean = false;
  hasBlood: boolean = false;
  hasAncillary: boolean = false;
  hasBloodProducts: boolean = false;
  hasAncillaryProducts: boolean = false;
  referrals: any = referrals;
  referralOtherSelected: boolean = false;
  referralOther: any;
  referralMeetingSelected: boolean = false;
  referralMeetingOtherSelected: boolean = false;
  meeting: any;
  meetingOther: any;
  form: any = {
    culturedIslets: false,
    acinar: false,
    bloodProd: false,
    ancillary: false,
    frozenIslets: false,
    histoSlides: false,
    study_Title: null,
    projAbstract: null,
    researchMethods: null,
    isletsReqReason: null,
    frozenPancreaticPcs: false,
    rationaleHistoSlides: null,
    rationaleFrozen: null,
    rationaleAcinar: null,
    rationaleAncillary: null,
    rationaleBlood: null,
    serum: false,
    plasma: false,
    lymphNode: false,
    spleen: false,
    duodenum: false,
    ductal: false,
    animalResearch: null,
    iacuC_Status: null,
    iacuC_App_No: null,
    iacuC_App_Dt: null,
    cellStimulus: false,
    cellDeath: false,
    type1Diabetes: false,
    tissueEngineering: false,
    alphaCells: false,
    geneticsGenomics: false,
    otherArea: false,
    otherAreaText: null,
    typeofStudy: '',
    comp_Dt: null,
    ieQs_Ideal: '',
    ieQs_Min: '',
    purity_Ideal: '',
    purity_Min: '',
    viability_Ideal: '',
    viability_Min: '',
    freq_Ideal: '',
    freq_Min: '',
    tot_IEQs_Needed: '',
    cultured_Ideal: '',
    cultured_Min: '',
    diabetic_Ideal: '',
    diabetic_Min: '',
    meetingSpecify: null,
    meeting: null,
    meetingOther: null,
    cultureLen: false,
    cultureMinDay: null,
    cultureMinHr: null,
    cultureMaxDay: null,
    cultureMaxHr: null,
    referrals: [],
    referralOther: null,
  };
  // investigatorReferralSource: [] = [];
  // selected: [];
  @Validations()
  validations: any = {
    form: {
      referrals: { required },
      referralOther: {
        requiredIf: requiredIf(
          (form: any) => this.form.referrals.indexOf(-9) !== -1,
        ),
        minLength: minLength(2),
      },
      meeting: {
        requiredIf: requiredIf(
            (form: any) => this.form.referrals.includes(4),
        ),
      },
      meetingSpecify: {},
      meetingOther: {
        requiredIf: requiredIf(
            (form: any) =>
            (this.form.meeting === -9 || this.form.meeting === '-9'),
        ),
        minLength: minLength(2),
      },
      culturedIslets: { required },
      frozenIslets: { required },
      histoSlides: { required },
      acinar: { required },
      bloodProd: { required },
      serum: {
        requiredIf: requiredIf((form: any) => form.bloodProd && !form.plasma),
      },

      plasma: {
        requiredIf: requiredIf((form: any) => form.bloodProd && !form.serum),
      },
      ancillary: { required },
      duodenum: {
        requiredIf: requiredIf(
          (form: any) =>
            form.ancillary &&
            !form.spleen &&
            !form.lymphNode &&
            !form.ductal &&
            !form.frozenPancreaticPcs,
        ),
      },
      ductal: {
        requiredIf: requiredIf(
          (form: any) =>
            form.ancillary &&
            !form.spleen &&
            !form.lymphNode &&
            !form.frozenPancreaticPcs &&
            !form.duodenum,
        ),
      },
      lymphNode: {
        requiredIf: requiredIf(
          (form: any) =>
            form.ancillary &&
            !form.spleen &&
            !form.ductal &&
            !form.frozenPancreaticPcs &&
            !form.duodenum,
        ),
      },

      spleen: {
        requiredIf: requiredIf(
          (form: any) =>
            form.ancillary &&
            !form.lymphNode &&
            !form.ductal &&
            !form.frozenPancreaticPcs &&
            !form.duodenum,
        ),
      },
      frozenPancreaticPcs: {
        requiredIf: requiredIf(
          (form: any) =>
            form.ancillary && !form.lymphNode && !form.ductal && !form.duodenum,
        ),
      },

      study_Title: {
        required,
        minLength: minLength(2),
      },
      projAbstract: {
        required,
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      typeofStudy: {},
      isletsReqReason: {
        requiredIf: requiredIf((form: any) => form.culturedIslets === true),
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      researchMethods: {
        required,
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      rationaleHistoSlides: {
        requiredIf: requiredIf((form: any) => form.histoSlides === true),
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      rationaleFrozen: {
        requiredIf: requiredIf((form: any) => form.frozenIslets),
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      rationaleAcinar: {
        requiredIf: requiredIf((form: any) => form.acinar),
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      rationaleBlood: {
        requiredIf: requiredIf((form: any) => form.bloodProd),
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },
      rationaleAncillary: {
        requiredIf: requiredIf((form: any) => form.ancillary),
        maxLength: maxLength(1000),
        minLength: minLength(2),
      },

      animalResearch: { required },
      iacuC_Status: {
        requiredIf: requiredIf((form: any) => form.animalResearch === true),
      },
      iacuC_App_No: {
        requiredIf: requiredIf((form: any) => form.iacuC_Status === '1'),
      },
      iacuC_App_Dt: {
        requiredIf: requiredIf((form: any) => form.iacuC_Status === '1'),
      },
      cellStimulus: { required },
      cellDeath: { required },
      type1Diabetes: { required },
      tissueEngineering: { required },
      alphaCells: { required },
      geneticsGenomics: { required },
      otherArea: { required },
      otherAreaText: {
        requiredIf: requiredIf((form: any) => {
          return form.otherArea === true;
        }),
        minLength: minLength(2),
      },
      comp_Dt: { required },
      ieQs_Ideal: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        validateIEQIdeal: this.validateIEQIdeal,
        between: between(1000, 10000000000),
      },
      ieQs_Min: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        validateIEQMin: this.validateIEQMin,
        between: between(1000, 10000000000),
      },
      purity_Ideal: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        between: between(0.000001, 100),
        validatePurityIdeal: this.validatePurityIdeal,
      },
      purity_Min: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        between: between(0.000001, 100),
        validatePurityMin: this.validatePurityMin,
      },
      viability_Ideal: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        between: between(0.000001, 100),
        validateViabilityIdeal: this.validateViabilityIdeal,
      },
      viability_Min: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        between: between(0.000001, 100),
        validateViabilityMin: this.validateViabilityMin,
      },
      freq_Ideal: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        between: between(1, 365),
        validateFreqIdeal: this.validateFreqIdeal,
      },
      freq_Min: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        between: between(1, 365),
        validateFreqMin: this.validateFreqMin,
      },
      tot_IEQs_Needed: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
        validateIAIAmount: this.validateIAIAmount,
      },
      cultured_Ideal: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
      },
      cultured_Min: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
      },
      diabetic_Ideal: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
      },
      diabetic_Min: {
        requiredIf: requiredIf(
          (form: any) => form.typeofStudy === 1 || form.culturedIslets,
        ),
      },
      cultureLen: {
        requiredIf: requiredIf((form: any) => form.culturedIslets),
      },
      cultureMinDay: {
        requiredIf: requiredIf(
          (form: any) =>
            form.cultureLen === true &&
            (form.cultureMinHr === '' || form.cultureMinHr === 0),
        ),
        between: between(0, 10),
        validateCultureDayMin: this.validateCultureDayMin,
      },
      cultureMinHr: {
        requiredIf: requiredIf(
          (form: any) =>
            form.cultureLen === true &&
            (form.cultureMinDay === '' || form.cultureMinDay === 0),
        ),
        between: between(0, 23.75),
        validateCultureHrMin: this.validateCultureHrMin,
      },
      cultureMaxDay: {
        requiredIf: requiredIf(
          (form: any) =>
            form.cultureLen === true &&
            (form.cultureMaxHr === '' || form.cultureMaxHr === 0),
        ),
        between: between(0, 10),
        validateCultureDayMax: this.validateCultureDayMax,
      },
      cultureMaxHr: {
        requiredIf: requiredIf(
          (form: any) =>
            form.cultureLen === true &&
            (form.cultureMaxDay === '' || form.cultureMaxDay === 0),
        ),
        between: between(0, 23.75),
        validateCultureHrMax: this.validateCultureHrMax,
      },
    },
  };
  @Watch('form.projAbstract')
  public onProjAbstractChanged(value: any) {
    if (value === '') {
      this.form.projAbstract = null;
    }
  }
  @Watch('form.researchMethods')
  public onResearchMethodsChanged(value: any) {
    if (value === '') {
      this.form.researchMethods = null;
    }
  }
  @Watch('form.isletsReqReason')
  public onisletsReqReasonChanged(value: any) {
    if (value === '') {
      this.form.isletsReqReason = null;
    }
  }
  @Watch('form.rationaleHistoSlides')
  public onRationaleHistoSlidesChanged(value: any) {
    if (value === '') {
      this.form.rationaleHistoSlides = null;
    }
  }
  @Watch('form.rationaleFrozen')
  public onRationaleFrozenChanged(value: any) {
    if (value === '') {
      this.form.rationaleFrozen = null;
    }
  }
  @Watch('form.rationaleAcinar')
  public onRationaleAcinarChanged(value: any) {
    if (value === '') {
      this.form.rationaleAcinar = null;
    }
  }

  @Watch('form.rationaleBlood')
  public onRationaleBloodChanged(value: any) {
    if (value === '') {
      this.form.rationaleBlood = null;
    }
  }
  @Watch('form.rationaleAncillary')
  public onRationaleAcillaryChanged(value: any) {
    if (value === '') {
      this.form.rationaleAcillary = null;
    }
  }
  @Watch('form.animalResearch')
  public onAnimalResearchChanged(value: any) {
    if (!value) {
      this.form.iacuC_Status = null;
      this.form.iacuC_App_Dt = null;
      this.form.iacuC_App_No = null;
    }
  }
  @Watch('form.iacuC_App_Dt')
  onIACUCDateChanged(value: any) {
    this.submit();
    this.$v.form.iacuC_App_Dt.$touch();
  }
  @Watch('form.iacuC_App_No')
  onIACUCNumberChanged(value: any) {
    this.submit();
    this.$v.form.iacuC_App_No.$touch();
  }
  @Watch('form.otherArea')
  public onotherAreaChanged(newValue: boolean, oldValue: boolean) {
    if (newValue === false) {
      this.form.otherAreaText = null;
    }
  }
  @Watch('form.acinar')
  public onAcinarChanged(value: any) {
    if (value === '') {
      this.form.rationaleAcinar = null;
    }
  }
  @Watch('form.culturedIlsets')
  public onCulturedIsletsChanged(value: any) {
    if (value === '') {
      this.form.researchMethods = null;
    }
  }
  @Watch('form.frozenIlsets')
  public onFrozenIsletsChanged(value: any) {
    if (value === '') {
      this.form.rationaleFrozen = null;
    }
  }
  @Watch('form.bloodProd')
  public onBloodProdChanged(value: any) {
    if (!value) {
      this.form.serum = 0;
      this.form.plasma = 0;
      this.form.rationaleBlood = null;
    }
    this.submit();
    this.$v.form.bloodProd.$touch();
  }
  @Watch('form.ancillary')
  public onAncillary(value: any) {
    if (!value) {
      this.form.duodenum = 0;
      this.form.spleen = 0;
      this.form.lymphNode = 0;
      this.form.ductal = 0;
      this.form.frozenPancreaticPcs = 0;
      this.form.rationaleAcillary = null;
    }
    this.submit();
    this.$v.form.ancillary.$touch();
  }
  @Watch('form.histoSlides')
  public onHistoSlidesChanged(value: any) {
    if (value === '') {
      this.form.rationaleHistoSlides = null;
    }
  }

  @Watch('form.cultureLen')
  public onCultureLenChanged(value: any) {
    if (value === false) {
      this.form.cultureLen = false;
      this.form.cultureMinDay = null;
      this.form.cultureMinHr = null;
      this.form.cultureMaxDay = null;
      this.form.cultureMaxHr = null;
    }
    this.submit();
    this.$v.form.cultureLen.$touch();
  }
  @Watch('form.referrals')
  public watchReferralChanged(value: any) {
    if (value.includes(-9)) {
      this.referralOtherSelected = true;
    } else {
      this.referralOtherSelected = false;
    }
    if (value.includes(4)) {
      this.referralMeetingSelected = true;
    } else {
      this.referralMeetingSelected = false;
      }
      if (this.referralMeetingSelected) {
          this.$v.form.meeting.$touch();
      } else {
          // If Meeting checkbox toggles off, clear & reset meeting fields/validation.
          this.form.meeting = null;
          this.form.meetingOther = null;
          this.$v.form.meeting.$reset();
          this.$v.form.meetingOther.$reset();
      }
      if (this.referralOtherSelected) {
          this.$v.form.referralOther.$touch();
      } else {
          this.form.referralOther = null;
          this.$v.form.referralOther.$reset();
      }
    this.submit();
    this.$v.form.referrals.$touch();
  }
    @Watch('form.meeting')
    public watchMeetingChanged(value: any) {
        this.$v.form.meeting.$touch();

        if (value) {
            this.referralMeetingSelected = true;
        } else {
            this.referralMeetingSelected = false;
        }

        const num = typeof value === 'string' ? Number(value) : value;
        this.$v.form.meeting.$touch();

      if (num !== -9) {
          this.form.meetingOther = null;
          this.$v.form.meetingOther.$touch();
          this.$v.form.meetingOther.$reset();
      } else {
          // If 'Other meeting', prompt validation
          this.$v.form.meetingOther.$touch();
      }
    this.submit();
    this.$v.form.meeting.$touch();
    }

  public culturedIsletsChanged(changed: any) {
    if (this.form.culturedIslets) {
      this.$emit('cultured-islets-changed', true);
    } else {
      this.$emit('cultured-islets-changed', false);
    }
  }
  public frozenChanged(changed: any) {
    if (this.form.frozenIslets) {
      this.$emit('frozen-islets-changed', true);
    } else {
      this.$emit('frozen-islets-changed', false);
    }
  }

  public acinarChanged(changed: any) {
    if (this.form.acinar) {
      this.$emit('acinar-changed', true);
    } else {
      this.$emit('acinar-changed', false);
    }
  }

  public histoChanged(changed: any) {
    if (this.form.histoSlides) {
      this.$emit('histo-changed', true);
    } else {
      this.$emit('histo-changed', false);
    }
  }
  public bloodProdChanged(changed: any) {
    if (this.form.bloodProd) {
      this.$emit('blood-prod-changed', true);
    } else {
      this.form.serum = null;
      this.form.plasma = null;
      this.$emit('blood-prod-changed', false);
    }
  }
  public bloodProductsCheckBoxChanged(changed: any) {
    if (this.form.serum || this.form.plasma) {
      this.$emit('blood-products-checkbox-changed', true);
    } else {
      this.$emit('blood-products-checkbox-changed', false);
    }
    this.submit();
  }
  public ancillaryChanged(changed: any) {
    if (this.form.ancillary) {
      this.$emit('ancillary-changed', true);
    } else {
      this.form.duodenum = null;
      this.form.spleen = null;
      this.form.lymphNode = null;
      this.form.frozenPancreaticPcs = null;
      this.form.ductal = null;
      this.$emit('ancillary-changed', false);
    }
  }
  public ancillaryCheckBoxChanged(changed: any) {
    if (
      this.form.duodenum ||
      this.form.spleen ||
      this.form.lymphNode ||
      this.form.frozenPancreaticPcs ||
      this.form.ductal
    ) {
      this.$emit('ancillary-checkbox-changed', true);
    } else {
      this.$emit('ancillary-checkbox-changed', false);
    }
    this.submit();
  }
  @Watch('form.comp_Dt')
  onCompDtChanged(value: any) {
    this.submit();
    this.$v.form.comp_Dt.$touch();
  }
  @Watch('userInfo.study.form', { deep: true })
  public formUpdated(newValue: any, oldValue: any) {
    setTimeout(() => {
      if (newValue !== oldValue) {
        if (this.userInfo.study.form.title !== null) {
          this.form.title = this.userInfo.study.form.title;
        }
        if (this.userInfo.study.form.pI_Phone !== null) {
          this.form.pI_Phone = this.userInfo.study.form.pI_Phone;
        }
        if (this.userInfo.study.form.pI_Phone_Ext !== null) {
          this.form.pI_Phone_Ext = this.userInfo.study.form.pI_Phone_Ext;
        }
        if (this.userInfo.study.form.pI_Email !== null) {
          this.form.pI_Email = this.userInfo.study.form.pI_Email;
        }
        if (this.userInfo.study.form.textMsg !== null) {
          this.form.textMsg = this.userInfo.study.form.textMsg;
        }
        if (this.userInfo.study.form.pI_Cell !== null) {
          this.form.pI_Cell = this.userInfo.study.form.pI_Cell;
        }
        if (this.userInfo.study.form.provider_ID !== null) {
          this.form.provider_ID = this.userInfo.study.form.provider_ID;
        }
        if (this.userInfo.study.form.pI_Address_1 !== null) {
          this.form.pI_Address_1 = this.userInfo.study.form.pI_Address_1;
        }
        if (this.userInfo.study.form.pI_Address_2 !== null) {
          this.form.pI_Address_2 = this.userInfo.study.form.pI_Address_2;
        }
        if (this.userInfo.study.form.pI_City !== null) {
          this.form.pI_City = this.userInfo.study.form.pI_City;
        }
        if (this.userInfo.study.form.pI_State !== null) {
          this.form.pI_State = this.userInfo.study.form.pI_State;
        }
        if (this.userInfo.study.form.pI_State_Oth !== null) {
          this.form.pI_State_Oth = this.userInfo.study.form.pI_State_Oth;
        }
        if (this.userInfo.study.form.pI_Province !== null) {
          this.form.pI_Province = this.userInfo.study.form.pI_Province;
        }
        if (this.userInfo.study.form.time_Zone !== null) {
          this.form.time_Zone = this.userInfo.study.form.time_Zone;
        }
        if (this.userInfo.study.form.timeZoneOther !== null) {
          this.form.timeZoneOther = this.userInfo.study.form.timeZoneOther;
        }
        if (this.userInfo.study.form.country !== null) {
          this.form.country = this.userInfo.study.form.country;
        }
        if (this.userInfo.study.form.pI_Zip !== null) {
          this.form.pI_Zip = this.userInfo.study.form.pI_Zip;
        }
        if (this.userInfo.study.form.hasORCID !== null) {
          this.form.hasORCID = this.userInfo.study.form.hasORCID;
        }
        if (this.userInfo.study.form.rsnNoORCID !== null) {
          this.form.rsnNoORCID = this.userInfo.study.form.rsnNoORCID;
        }
        if (this.userInfo.study.form.orcid !== null) {
          this.form.orcid = this.userInfo.study.form.orcid;
        }
        if (this.userInfo.study.form.wKShipment != null) {
          this.form.wKShipment = this.userInfo.study.form.wKShipment;
        }
        if (this.userInfo.study.form.shippingNote != null) {
          this.form.shippingNote = this.userInfo.study.form.shippingNote;
        }
        if (this.userInfo.study.form.sameasMailing != null) {
          this.form.sameasMailing = this.userInfo.study.form.sameasMailing;
        }
        if (this.userInfo.study.form.wK_Contact != null) {
          this.form.wK_Contact = this.userInfo.study.form.wK_Contact;
        }
        if (this.userInfo.study.form.wK_Phone != null) {
          this.form.wK_Phone = this.userInfo.study.form.wK_Phone;
        }
        if (this.userInfo.study.form.wKShipment != null) {
          this.form.wKShipment = this.userInfo.study.form.wKShipment;
        }
        if (this.userInfo.study.form.wksameasMailing != null) {
          this.form.wksameasMailing = this.userInfo.study.form.wksameasMailing;
        }
        if (this.userInfo.study.form.shipCountry !== null) {
          this.form.shipCountry = this.userInfo.study.form.shipCountry;
        }
        if (this.userInfo.study.form.ship_Addr_1 !== null) {
          this.form.ship_Addr_1 = this.userInfo.study.form.ship_Addr_1;
        }
        if (this.userInfo.study.form.ship_Addr_2 !== null) {
          this.form.ship_Addr_2 = this.userInfo.study.form.ship_Addr_2;
        }
        if (this.userInfo.study.form.ship_City !== null) {
          this.form.ship_City = this.userInfo.study.form.ship_City;
        }
        if (this.userInfo.study.form.ship_State !== null) {
          this.form.ship_State = this.userInfo.study.form.ship_State;
        }
        if (this.userInfo.study.form.wkShipCountry !== null) {
          this.form.wkShipCountry = this.userInfo.study.form.wkShipCountry;
        }
        if (this.userInfo.study.form.wK_Ship_Addr_1 !== null) {
          this.form.wK_Ship_Addr_1 = this.userInfo.study.form.wK_Ship_Addr_1;
        }
        if (this.userInfo.study.form.wK_Ship_Addr_1 !== null) {
          this.form.wK_Ship_Addr_2 = this.userInfo.study.form.wK_Ship_Addr_2;
        }
        if (this.userInfo.study.form.wK_Ship_City !== null) {
          this.form.wK_Ship_City = this.userInfo.study.form.wK_Ship_City;
        }
        if (this.userInfo.study.form.wK_Ship_State !== null) {
          this.form.wK_Ship_State = this.userInfo.study.form.wK_Ship_State;
        }
        if (this.userInfo.study.form.wK_Ship_Zip !== null) {
          this.form.wK_Ship_Zip = this.userInfo.study.form.wK_Ship_Zip;
        }
        if (this.userInfo.study.form.wK_Ship_Province !== null) {
          this.form.wK_Ship_Province = this.userInfo.study.form.wK_Ship_Province;
        }
        if (this.userInfo.study.form.wK_Ship_State_Oth !== null) {
          this.form.wK_Ship_State_Oth = this.userInfo.study.form.wK_Ship_State_Oth;
        }
        // Funding Info
        if (this.userInfo.study.form.pilot !== null) {
          this.form.pilot = this.userInfo.study.form.pilot;
        }

        if (this.userInfo.study.form.non_Profit !== null) {
          this.form.non_Profit = this.userInfo.study.form.non_Profit;
        }
        if (this.userInfo.study.form.peer_Rev_Grant !== null) {
          this.form.peer_Rev_Grant = this.userInfo.study.form.peer_Rev_Grant;
        }
        if (this.userInfo.study.form.fundsAva !== null) {
          this.form.fundsAva = this.userInfo.study.form.fundsAva;
        }
      }
    }, 1000);
  }

  get userInfo() {
    return store.userInfo;
  }
  validateForm() {
    return this.$v.$invalid;
  }
  dateConverter(d: any) {
    d = moment.utc(d).format('MM/DD/YYYY');
    // d = moment(new Date(d)).format('MM/DD/YYYY')
    if (d !== 'Invalid date') {
      return moment.utc(d).format('MM/DD/YYYY');
    }
  }
  isGreaterThanZero(value: any) {
    if (value.keyCode >= 48 && value.keyCode <= 57) {
      return true;
    } else {
      value.preventDefault();
    }
  }
  remaincharCount() {
    if (
      this.form.projAbstract !== null &&
      this.form.projAbstract.length > 1000
    ) {
      this.exceedingAbstractText = this.form.projAbstract.slice(1000, 2000);
      const remainCharacters = this.exceedingAbstractText.length;
      this.remaincharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
      this.remainSpecificAimscharactersText = '';
    } else {
      const remainCharacters =
        1000 -
        (this.form.projAbstract === null ? 0 : this.form.projAbstract.length);
      this.exceedingAbstractText = '';
      this.remainAbstractCharactersText = '';
      this.remainSpecificAimscharactersText =
        'Remaining ' + remainCharacters + ' characters.';
    }
  }

  remaincharMethodCount() {
    if (
      this.form.researchMethods !== null &&
      this.form.researchMethods.length > 1000
    ) {
      this.exceedingResearchMethodsText = this.form.researchMethods.slice(
        1000,
        2000,
      );
      const remainCharacters = this.exceedingResearchMethodsText.length;
      this.remainmethodcharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
      this.remainingResearchMethodsCharactersText = '';
    } else {
      const remainCharacters =
        1000 -
        (this.form.researchMethods === null
          ? 0
          : this.form.researchMethods.length);
      this.exceedingResearchMethodsText = '';
      this.remainingResearchMethodsCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
    }
  }
  remaincharIsletCount() {
    const val = this.form.isletsReqReason || '';
    const len = val.length;
    if (len < 2) {
      this.reqIsletText =
        'Rationale: Freshly-Cultured Isolated Islets is required and must be at least 2 characters long.';
      this.remainingIsletsCharactersText = '';
      this.remainisletcharactersText = '';
      this.exceedingIsletsText = '';
    } else if (len > 1000) {
      this.reqIsletText = '';
      this.remainingIsletsCharactersText = '';
      this.exceedingIsletsText = this.form.isletsReqReason.slice(1000, 2000);
      const remainCharacters = this.exceedingIsletsText.length;
      this.remainisletcharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
    } else {
      const remainCharacters =
        1000 -
        (this.form.isletsReqReason === null
          ? 0
          : this.form.isletsReqReason.length);
      this.remainingIsletsCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
      this.exceedingIsletsText = '';
    }
  }
  remaincharHistoCount() {
    const val = this.form.rationaleHistoSlides || '';
    const len = val.length;

    if (len < 2) {
      this.reqHistoText =
        'Rationale: Formalin-Fixed Pancreas Tissue Sections (Histology Slides) is required and must be at least 2 characters long.';
      this.remainingHistoSlidesCharactersText = '';
      this.remainhistocharactersText = '';
      this.exceedingHistoSlidesText = '';
    } else if (len > 1000) {
      this.reqHistoText = '';
      this.remainingHistoSlidesCharactersText = '';
      this.exceedingHistoSlidesText = this.form.rationaleHistoSlides.slice(
        1000,
        2000,
      );
      const remainCharacters = this.exceedingHistoSlidesText.length;
      this.remainhistocharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
    } else {
      const remainCharacters =
        1000 -
        (this.form.rationaleHistoSlides === null
          ? 0
          : this.form.rationaleHistoSlides.length);
      this.remainingHistoSlidesCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
    }
  }
  remaincharAcinarCount() {
    const val = this.form.rationaleAcinar || '';
    const len = val.length;

    if (len < 2) {
      this.reqAcinarText =
        'Rationale: Non‑Islet Pancreatic Tissue (Acinar) is required and must be at least 2 characters long.';
      this.remainingAcinarCharactersText = '';
      this.remainacinarcharactersText = '';
      this.exceedingAcinarText = '';
    } else if (len > 1000) {
      this.exceedingAcinarText = this.form.rationaleAcinar.slice(1000, 2000);
      const remainCharacters = this.exceedingAcinarText.length;
      this.reqAcinarText = '';
      this.remainingAcinarCharactersText = '';
      this.remainacinarcharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
    } else {
      this.exceedingAcinarText = '';
      const remainCharacters =
        1000 -
        (this.form.rationaleAcinar === null
          ? 0
          : this.form.rationaleAcinar.length);
      this.remainingAcinarCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
    }
  }
  remaincharFrozenCount() {
    const val = this.form.rationaleFrozen || '';
    const len = val.length;

    if (len < 2) {
      this.reqFrozenText =
        'Rationale: Flash Frozen Isolated Islets is required and must be at least 2 characters long.';
      this.remainingFrozenIsletsCharactersText = '';
      this.remainfrozencharactersText = '';
      this.exceedingFrozenIsletsText = '';
    } else if (len > 1000) {
      this.reqFrozenText = '';
      this.exceedingFrozenIsletsText = this.form.rationaleFrozen.slice(
        1000,
        2000,
      );
      const remainCharacters = this.exceedingFrozenIsletsText.length;
      this.remainfrozencharactersText =
        'Exceeded ' +
        1000 +
        ' characters limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
      this.remainingFrozenIsletsCharactersText = '';
    } else {
      this.exceedingFrozenIsletsText = '';
      const remainCharacters =
        1000 -
        (this.form.rationaleFrozen === null
          ? 0
          : this.form.rationaleFrozen.length);
      this.remainingFrozenIsletsCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
      this.exceedingFrozenIsletsText = '';
    }
  }

  remaincharBloodCount() {
    const val = this.form.rationaleBlood || '';
    const len = val.length;

    if (len < 2) {
      this.reqBloodText =
        'Rationale: Blood Products is required and must be at least 2 characters long.';
      // clear out any character‑count messages
      this.remainingBloodCharactersText = '';
      this.remainBloodcharactersText = '';
      this.exceedingBloodText = '';
    } else if (len > 1000) {
      this.exceedingBloodText = this.form.rationaleBlood.slice(1000, 2000);
      const remainCharacters = this.exceedingBloodText.length;
      this.reqBloodText = '';
      this.remainingBloodCharactersText = '';
      this.remainBloodcharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
    } else {
      this.exceedingBloodText = '';
      const remainCharacters =
        1000 -
        (this.form.rationaleBlood === null
          ? 0
          : this.form.rationaleBlood.length);
      this.remainingBloodCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
    }
  }

  remaincharAncillaryCount() {
    const val = this.form.rationaleAncillary || '';
    const len = val.length;

    if (len < 2) {
      this.reqAncillaryText =
        'Rationale: Ancillary Tissues is required and must be at least 2 characters long.';
      this.remainingAncillaryCharactersText = '';
      this.remainAncillarycharactersText = '';
      this.exceedingAncillaryText = '';
    } else if (len > 1000) {
      this.exceedingAncillaryText = this.form.rationaleAncillary.slice(
        1000,
        2000,
      );
      const remainCharacters = this.exceedingAncillaryText.length;
      this.reqAncillaryText = '';
      this.remainingAncillaryCharactersText = '';
      this.remainAncillarycharactersText =
        'Exceeded ' +
        1000 +
        ' character limit by ' +
        remainCharacters +
        ' characters. Please consider removing the following text: ';
    } else {
      this.exceedingAncillaryText = '';
      const remainCharacters =
        1000 -
        (this.form.rationaleAncillary === null
          ? 0
          : this.form.rationaleAncillary.length);
      this.remainingAncillaryCharactersText =
        'Remaining ' + remainCharacters + ' characters.';
    }
  }

  validateIEQIdeal() {
    if (
      parseInt(this.form.ieQs_Ideal, 10) <= parseInt(this.form.ieQs_Min, 10)
    ) {
      return false;
    } else {
      return true;
    }
  }
  validateIAIAmount() {
    if (
      this.userInfo.study.form.pilot === true &&
      parseInt(this.form.tot_IEQs_Needed, 10) > 100000
    ) {
      return false;
    } else {
      return true;
    }
  }
  validateIEQMin() {
    if (
      parseInt(this.form.ieQs_Min, 10) >= parseInt(this.form.ieQs_Ideal, 10)
    ) {
      return false;
    } else {
      return true;
    }
  }
  validatePurityIdeal() {
    if (
      parseInt(this.form.purity_Ideal, 10) <= parseInt(this.form.purity_Min, 10)
    ) {
      return false;
    } else {
      return true;
    }
  }
  validatePurityMin() {
    if (
      parseInt(this.form.purity_Min, 10) >= parseInt(this.form.purity_Ideal, 10)
    ) {
      return false;
    } else {
      return true;
    }
  }
  validateViabilityMin() {
    if (
      parseInt(this.form.viability_Min, 10) >=
      parseInt(this.form.viability_Ideal, 10)
    ) {
      return false;
    } else {
      return true;
    }
  }
  validateViabilityIdeal() {
    if (
      parseInt(this.form.viability_Ideal, 10) <=
      parseInt(this.form.viability_Min, 10)
    ) {
      return false;
    } else {
      return true;
    }
  }
  validateFreqIdeal() {
    if (parseInt(this.form.freq_Ideal, 10) > parseInt(this.form.freq_Min, 10)) {
      return false;
    } else {
      return true;
    }
  }
  validateFreqMin() {
    if (parseInt(this.form.freq_Min, 10) < parseInt(this.form.freq_Ideal, 10)) {
      return false;
    } else {
      return true;
    }
  }
  validateCultureDayMin() {
    const hourMin = isNaN(parseInt(this.form.cultureMinHr, 10))
      ? 0
      : parseInt(this.form.cultureMinHr, 10);
    const hourMax = isNaN(parseInt(this.form.cultureMaxHr, 10))
      ? 0
      : parseInt(this.form.cultureMaxHr, 10);
    const dayMin = isNaN(parseInt(this.form.cultureMinDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMinDay, 10);
    const dayMax = isNaN(parseInt(this.form.cultureMaxDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMaxDay, 10);
    const max = dayMax + hourMax;
    const min = dayMin + hourMin;
    if (min === 0 || max === 0 || max < min) {
      return false;
    } else {
      return true;
    }
  }
  validateCultureDayMax() {
    const hourMin = isNaN(parseInt(this.form.cultureMinHr, 10))
      ? 0
      : parseInt(this.form.cultureMinHr, 10);
    const hourMax = isNaN(parseInt(this.form.cultureMaxHr, 10))
      ? 0
      : parseInt(this.form.cultureMaxHr, 10);
    const dayMin = isNaN(parseInt(this.form.cultureMinDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMinDay, 10);
    const dayMax = isNaN(parseInt(this.form.cultureMaxDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMaxDay, 10);
    const max = dayMax + hourMax;
    const min = dayMin + hourMin;
    if (min === 0 || max === 0 || max < min) {
      return false;
    } else {
      return true;
    }
  }
  validateCultureHrMin() {
    const hourMin = isNaN(parseInt(this.form.cultureMinHr, 10))
      ? 0
      : parseInt(this.form.cultureMinHr, 10);
    const hourMax = isNaN(parseInt(this.form.cultureMaxHr, 10))
      ? 0
      : parseInt(this.form.cultureMaxHr, 10);
    const dayMin = isNaN(parseInt(this.form.cultureMinDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMinDay, 10);
    const dayMax = isNaN(parseInt(this.form.cultureMaxDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMaxDay, 10);
    const max = dayMax + hourMax;
    const min = dayMin + hourMin;
    if (min === 0 || max === 0 || max < min) {
      return false;
    } else {
      return true;
    }
  }
  validateCultureHrMax() {
    const hourMin = isNaN(parseInt(this.form.cultureMinHr, 10))
      ? 0
      : parseInt(this.form.cultureMinHr, 10);
    const hourMax = isNaN(parseInt(this.form.cultureMaxHr, 10))
      ? 0
      : parseInt(this.form.cultureMaxHr, 10);
    const dayMin = isNaN(parseInt(this.form.cultureMinDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMinDay, 10);
    const dayMax = isNaN(parseInt(this.form.cultureMaxDay, 10))
      ? 0
      : 24 * parseInt(this.form.cultureMaxDay, 10);
    const max = dayMax + hourMax;
    const min = dayMin + hourMin;
    if (min === 0 || max === 0 || max < min) {
      return false;
    } else {
      return true;
    }
  }
  submit() {
    const formClone = deepClone(this.form);
    this.$emit('update', {
      formData: formClone,
      id: 3,
      isValid: !this.$v.$invalid,
      readyToSave: this.isHydrated || this.userInteracted,
    });
  }

  created() {
    bus.$off('userInfo', this.onUserInfo);
    bus.$on('userInfo', this.onUserInfo);
    const cached = (window as any).__lastUserInfo || (this as any).userInfo;
    if (cached?.study) {
      this.onUserInfo(cached);
    }
  }

  beforeDestroy() {
    bus.$off('userInfo', this.onUserInfo);
  }
  activated() {
    if (
      this.userInfo.study !== undefined &&
      this.userInfo.study.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.study.form);
    }
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.study.form);
    });
  }
  mounted() {
    this.loadToForm();
    this.validateForm();
    this.$v.$reset();
  }
  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.study.form);
      Object.assign(this.form, payload.study.referralList);
      this.form.referrals = this.userInfo.study.referralList;
      this.form.referralOther = this.userInfo.study.referralOther;
      this.form.meetingOther = this.userInfo.study.meetingOther;
      this.form.meeting = this.userInfo.study.meeting;
      this.referralOtherSelected = this.form.referrals.indexOf(-9) !== -1;
      this.referralMeetingSelected = this.form.referrals.includes(4);
      this.referralMeetingOtherSelected = this.form.meeting.indexOf(-9) !== -1;
    });
  }
  onReferralChange() {
    this.userInteracted = true;
    this.referralOtherSelected = this.form.referrals.includes(-9);
    this.referralMeetingSelected = this.form.referrals.includes(4);
    this.submit();
  }

  public researchCheckBoxChanged(changed: any) {
    if (
      this.form.cellDeath === true ||
      this.form.cellStimulus === true ||
      this.form.type1Diabetes === true ||
      this.form.tissueEngineering === true ||
      this.form.alphaCells === true ||
      this.form.geneticsGenomics === true ||
      this.form.otherArea === true
    ) {
      this.$emit('research-area-changed', true);
    } else {
      this.$emit('research-area-changed', false);
    }
  }
  public animalResearchChanged(changed: any) {
    if (this.form.animalResearch) {
      this.$emit('animal-research-changed', true);
    } else {
      this.$emit('animal-research-changed', false);
    }
  }
  public iacuCNumberChanged(changed: any) {
    if (this.form.iacuC_App_No) {
      this.$emit('iacuc-number-changed', true);
    } else {
      this.$emit('iacuc-number-changed', false);
    }
  }
  private onUserInfo = (payload: any) => {
    const s = payload?.study ?? {};
    const referrals = Array.isArray(s.referralList)
      ? s.referralList.map(Number).filter(Number.isFinite)
      : [];
      let meeting = null;
    if (s.meeting !== undefined && s.meeting !== null && s.meeting !== '') {
      const m = Number(s.meeting);
      meeting = Number.isFinite(m) ? m : null;
      }
    const meetingOther = s.meetingOther ?? s.meetingOtherText ?? '';
    const referralOther = s.referralOther ?? '';
    Object.assign(this.form, {
      referrals,
      referralOther,
      meeting,
      meetingOther,
    });
    this.isHydrated = true;
  }
}
